import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const defaultMiddleware = [thunk];

export default function configureStore({ rootReducer, initialState = {}, middleware = defaultMiddleware }) {
    return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
}
